import React from 'react';
import { ReportingContainerBaseConfig } from '../../base';
import { TaskListController, TaskListLoader } from './taskListInterface';
import { TaskListContainerProps, TaskListViewProps } from './taskListProps';
import { useNavigate } from 'react-router';

export function createTaskListContainer(
    config: ReportingContainerBaseConfig,
    loader: TaskListLoader,
    controller: TaskListController,
    View: React.FC<TaskListViewProps>
): React.FC<TaskListContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        repository,
        context: { useContext },
        state: states,
    } = config;

    return ({ ...containerProps }) => {
        const context = useContext();

        const data = loader.useLoad(context, {});
        const props = controller.useProps(context, data, {
            link: {
                empty: {
                    path: '../home',
                },
            },
        });
        return <View {...props} />;
    };
}
